import React from "react"

const FooterLink = ({linkTo, text}) => {
    return (
        <a href={linkTo} className="d-flex align-items-center">
            <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
            <p className="footer-link-text">{text}</p>
        </a>
    )
}

export default FooterLink